import React, { useEffect, useState } from "react";
import styles from "./StudentFunding.module.css";
import Image from "next/image";
import { ArrowRight } from "lucide-react";
import CustomiseCta from "../CustomiseCta/CustomiseCta";

interface ImageData {
  id: number;
  documentId: string;
  url: string;
  alternativeText?: string;
}

interface CardWithImage {
  id: number;
  title_description: {
    id: number;
    title: string;
    description: string;
  };
  images: ImageData[];
  mobiles_images: any;
}

interface StudentFundingData {
  card_with_image: CardWithImage;
  cta: any;
  link: {
    id: number;
    label: string;
    url: string;
  };
}

interface StudentFundingProps {
  data?: StudentFundingData;
  programPage?: boolean;
}
const MemoizedCustomiseCta = React.memo(CustomiseCta);
const StudentFunding: React.FC<StudentFundingProps> = ({
  data,
  programPage,
}) => {
  const { card_with_image, cta, link } = data || {};
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    if (typeof window !== "undefined") {
      const handleResize = () => {
        setIsMobile(window.innerWidth <= 767);
      };

      handleResize();
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }
  }, []);

  const banner =
    (isMobile
      ? card_with_image?.mobiles_images?.[0]?.url ||
        card_with_image?.mobiles_images?.url
      : card_with_image?.images?.[0]?.url) || card_with_image?.images?.[0]?.url;

  return (
    <div
      className={styles.studentFunding}
      style={{
        height: programPage ? "300px" : "376px",
        minHeight: "350px",
        maxHeight: "400px",
        overflow: "hidden",
      }}
      data-section="StudentFunding"
    >
      {banner && (
        <Image
          src={banner}
          alt={card_with_image?.images[0]?.alternativeText || "Student-Funding"}
          title={
            card_with_image?.images[0]?.alternativeText || "Student-Funding"
          }
          className={styles.backgroundImage}
          width={500}
          height={500}
          loading="lazy"
          style={{ objectFit: "cover", width: "100%", height: "100%" }}
        />
      )}
      <div className={styles.overlay}>
        <div className={styles.content}>
          <h2 className={programPage ? styles.ProgrampageTitle : styles.title}>
            {card_with_image?.title_description?.title}
          </h2>
          <p
            className={
              programPage ? styles.ProgrampageDescription : styles.description
            }
          >
            {card_with_image?.title_description?.description}
          </p>
        </div>
        <div className={styles.buttonWrapper}>
          <div
            className={
              programPage ? styles.ProgrampageButten : styles.buttonNormal
            }
          >
            <MemoizedCustomiseCta
              btnLabelDesktop={link?.label || "Learn more"}
              ctaData={cta}
              position="left"
              reactIconsRight={<ArrowRight aria-hidden="true" />}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default StudentFunding;
